module.exports = __webpack_public_path__ + "img/logo-white.4dc4b53e.svg";